<template>
    <component :is="as" ref="element">
        <slot></slot>
    </component>
</template>
<script>
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';

export default {
    props: {
        as: {
            type: String,
            default: 'div'
        },
        text: {
            type: String,
            required: true
        }
    },
    mounted() {
        tippy(this.$el, {
            content: this.text
        })
    }
}
</script>
